import { render, staticRenderFns } from "./SwitchField.vue?vue&type=template&id=5f6ef5cc&scoped=true"
import script from "./SwitchField.vue?vue&type=script&lang=js"
export * from "./SwitchField.vue?vue&type=script&lang=js"
import style0 from "./SwitchField.vue?vue&type=style&index=0&id=5f6ef5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ef5cc",
  null
  
)

export default component.exports